import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { IcecontrolSettings, IcepanelSettings, PaymentMethods } from '../../../../icemedx-lib/src/components/models/icesettings';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { claimindex } from '../../../../icemedx-lib/src/models/accounting/claim/claimindex';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { servicepaymentreference } from '../../../../icemedx-lib/src/models/accounting/servicepaymentreference';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';

@Component({
  selector: 'singleservicehistory',
  templateUrl: './singleservicehistory.component.html',
  styleUrls: ['./singleservicehistory.component.scss']
})
export class SingleservicehistoryComponent implements OnInit {
  @Input() show: boolean = true;
  @Input() service: medicalservice = null;
  @Input() responsibleParties: any[] = [];
  @Input() history: chargehistory = null;
  @Input() panelSync: IcepanelSettings = null;

  @Output() postPaymentClick: EventEmitter<any> = new EventEmitter<any>();

  acctHistoryNone: number = 0;
  acctHistoryJournal: number = 1;
  acctHistoryLedger: number = 2;
  acctHistoryClaims: number = 3;
  acctHistoryPayments: number = 4;

  historyTypes = [
    { value: this.acctHistoryNone, name: "" },
    { value: this.acctHistoryJournal, name: "Journal" },
    { value: this.acctHistoryLedger, name: "Ledger" },
    { value: this.acctHistoryClaims, name: "Claims" },
    { value: this.acctHistoryPayments, name: "Payments and Adjustments" },
  ];

  historyTypeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "50%" }, null, null, "historyType", "Accounting History")
    .setControlName("historyType")
    .createFormControl("", [])
    .setOptions(this.historyTypes);

  selectedHistory: number = this.acctHistoryNone;
  journalList: any[] = [];
  ledgerList: any[] = [];
  postingList: any[] = [];
  claimList: any[] = [];

  postDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "Date of Post", width: "125px" }, null, null, "PostDate")
    .setControlName("PostDate")
    .createFormControl(Iceutility.GetLocalDate(), [Validators.required]);;

  copayAdjTypes = [
    { value: IceTypes.coa_types.coaCoPayAR, name: "Co-Pay Payment" },
    { value: IceTypes.coa_types.coaDiscount, name: "Discount" },
    { value: IceTypes.coa_types.coaClaimAdjustment, name: "Claim Adjustments" },
    { value: IceTypes.coa_types.coaDisallowedAdjustment, name: "Disallowed Adjustment" },
    { value: IceTypes.coa_types.coaContractualObligationsAdjustment, name: "Contractual Obligations Adjustment" },
    { value: IceTypes.coa_types.coaCorrectionandReversalsAdjustment, name: "Correction / Reversals Adjustment" },
  ];

  payAdjTypes = [
    { value: IceTypes.coa_types.coaAR, name: "Service Payment" },
    { value: IceTypes.coa_types.coaCoInsuranceAR, name: "Co-Insurance Payment" },
    { value: IceTypes.coa_types.coaDeductibleAR, name: "Deductible Payment" },
    { value: IceTypes.coa_types.coaDiscount, name: "Discount" },
    { value: IceTypes.coa_types.coaClaimAdjustment, name: "Claim Adjustments" },
    { value: IceTypes.coa_types.coaDisallowedAdjustment, name: "Disallowed Adjustment" },
    { value: IceTypes.coa_types.coaContractualObligationsAdjustment, name: "Contractual Obligations Adjustment" },
    { value: IceTypes.coa_types.coaCorrectionandReversalsAdjustment, name: "Correction / Reversals Adjustment" },
  ];

  postChargeType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostChargeType", "Pay/Adj. Type")
    .setControlName("PostChargeType")
    .createFormControl(IceTypes.coa_types.coaAR, [Validators.required])
    .setOptions(this.payAdjTypes);

  postNotesCtrl: IcecontrolSettings = new IcecontrolSettings("icetextarea", { width: "100%", height: "200px" }, null, null, "PostNotes", "Notes")
    .setControlName("PostNotes")
    .createFormControl("", []);

  postRefCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "PostRef", "Ref. Info.")
    .setControlName("PostRef")
    .createFormControl("", []);

  postResponsibleParty: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostResponsibleParty", "Responsible Party")
    .setControlName("PostResponsibleParty")
    .createFormControl(0, []);

  postAmount: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "Paid", "Post Amount")
    .setControlName("PostAmount")
    .createFormControl(0.0, []);

  postCashAccount: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostCashAccount", "Cash Account")
    .setControlName("PostCashAccount")
    .createFormControl(IceTypes.coa_types.coaCashPrimary, [Validators.required])
    .setOptions([
      { value: IceTypes.coa_types.coaCashPetty, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashPetty) },
      { value: IceTypes.coa_types.coaCashPrimary, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashPrimary) },
      { value: IceTypes.coa_types.coaCashSecondary, name: AccountingService.getCoaType(IceTypes.coa_types.coaCashSecondary) },
    ]);

  postPayType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "PostPayType", "Pay Type")
    .setControlName("PostPayType")
    .createFormControl(PaymentMethods.pmCash, [Validators.required])
    .setOptions([
      { value: PaymentMethods.pmNone, name: "N/A" },
      //{ value: PaymentMethods.pmCreditCard, name: "Credit Card" },
      //{ value: PaymentMethods.pmBankAccount, name: "Check" },
      { value: PaymentMethods.pmCash, name: "Cash" },
    ]);

  postButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Post", glyphClass: "fa-plus-circle" }, null, null, "PostButton");

  constructor(private medCodeSvc: MedicalcodesService) { }

  getChargeType(): IceTypes.coa_types {
    if (this.service == null) return IceTypes.coa_types.coaServiceIncome;

    return Iceutility.toLong(this.service.inc_coa_type);
  }

  isReadyOnly(): boolean {
    if (this.service == null) return true;

    return Iceutility.toLong(this.service.trans_status) != IceTypes.trans_status.isNone;
  }

  getShow(): boolean {
    if (this.service == null || this.service.medical_service_key.length == 0) return false;

    return this.show;
  }

  initializeControls(): void {
    this.selectedHistory = this.acctHistoryNone;
    this.historyTypeCtrl.getFormControl().setValue(this.selectedHistory);
    this.historyTypeChanged(this.selectedHistory);

    // setup the posting fields
    this.postResponsibleParty.setOptions(this.responsibleParties);

    this.resetPostingControls();
  }

  ngOnInit() {
    if (this.panelSync != null) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          this.initializeControls();
        },
        error => {
        }
      );
    }
    else {
      this.initializeControls();
    }
  }

  resetPostingControls(): void {
    let defPostType = IceTypes.coa_types.coaAR;
    switch (this.getChargeType()) {
      case IceTypes.coa_types.coaServiceIncome:
      case IceTypes.coa_types.coaOtherIncome:
        {
          defPostType = IceTypes.coa_types.coaAR;
          this.postChargeType.setOptions(this.payAdjTypes);
          break;
        }
      case IceTypes.coa_types.coaCoPayIncome:
        {
          defPostType = IceTypes.coa_types.coaCoPayAR;
          this.postChargeType.setOptions(this.copayAdjTypes);
          break;
        }
    }

    this.postChargeType.getFormControl().setValue(defPostType);
    if (this.service != null)
      this.postResponsibleParty.getFormControl().setValue(AccountingService.getPartyBucketKey(this.service));
    else
      this.postResponsibleParty.getFormControl().setValue("");

    this.postPayType.getFormControl().setValue(PaymentMethods.pmCash);
    this.postCashAccount.getFormControl().setValue(IceTypes.coa_types.coaCashPrimary);
    this.postDateCtrl.getFormControl().setValue(Iceutility.GetLocalDate());
    this.postNotesCtrl.getFormControl().setValue("");
    this.postRefCtrl.getFormControl().setValue("");
    this.postAmount.getFormControl().setValue(0);

    this.postPayType.setDisabled(false);
    this.postCashAccount.setDisabled(false);
  }

  historySelectChange(event): void {
    this.selectedHistory = event.value;
    this.historyTypeChanged(this.selectedHistory);
  }

  historyTypeChanged(selHistory: number): void {
    this.journalList = [];
    this.ledgerList = [];
    this.postingList = [];
    this.claimList = [];

    if (this.service == null || this.history == null) return;

    switch (selHistory) {
      case this.acctHistoryJournal: {
        let jrnldata = this.history.getServiceIncomes(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: incomerevenuejournal = <incomerevenuejournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.income_revenue_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: rec.journal_note,
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        jrnldata = this.history.getServiceAssets(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: assetjournal = <assetjournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.asset_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: rec.journal_note,
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        jrnldata = this.history.getServiceExpenses(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: expensejournal = <expensejournal>jrnldata[irec];
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          let entry = {
            journal_key: rec.expense_journal_key,
            medical_service_key: rec.medical_service_key,
            origical_date: rec.journal_date,
            journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            coa_type: AccountingService.getCoaType(rec.coa_type),
            journal_desc: rec.journal_desc,
            journal_note: "",
            journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
            otherifo: "",
            debit: debit,
            credit: credit,
          };
          this.journalList.push(entry);
        }

        this.journalList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
      case this.acctHistoryLedger: {
        let balance = 0.0;
        let jrnldata = this.history.getServiceAssets(this.service.medical_service_key);
        for (let irec = 0; jrnldata != null && irec < jrnldata.length; irec++) {
          let rec: assetjournal = <assetjournal>jrnldata[irec];
          let charge = Iceutility.toDouble(rec.debit);

          let ctyp = Iceutility.toLong(rec.coa_type);
          let srcTyp = Iceutility.toLong(rec.src_type);
          if (IceTypes.coa_types.coaAR == ctyp
            && (IceTypes.SourceType.srcService == srcTyp
              || IceTypes.SourceType.srcUndefined == srcTyp)) {

            balance += charge;
            let descSuffix = "Service";
            let entry = {
              journal_key: rec.asset_journal_key,
              medical_service_key: rec.medical_service_key,
              origical_date: rec.journal_date,
              date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
              trans_account: rec.trans_account,
              account_type: Iceutility.toLong(rec.account_type),
              coa_type: AccountingService.getCoaType(rec.coa_type),
              desc: rec.journal_desc + " - " + descSuffix,
              note: rec.journal_note,
              code: rec["journal_code"] != null ? rec["journal_code"] : "",
              otherifo: "",
              charge: charge,
              credit: "",
              balance: balance
            };
            this.ledgerList.push(entry);
          }
        }

        let postdata = this.history.getAllServicePostings(this.service.medical_service_key);
        for (const postkey in postdata) {
          let thispost: payment = postdata[postkey];
          for (let iref = 0; thispost != null && iref < thispost.SERVICES.length; iref++) {
            let rec: servicepaymentreference = thispost.SERVICES[iref];
            let respName = "", respKey = AccountingService.getPartyBucketKeyEx(rec.subscriber_key, rec.coverage_key, rec.payer_key);
            let foundResp = this.responsibleParties.filter(r => r.value == respKey);
            if (foundResp.length > 0)
              respName = foundResp[0].name;
            else
              respName = "Unknown";

            let descSuffix = "Service";
            let ctyp = Iceutility.toLong(rec.coa_type);
            switch (ctyp) {
              case IceTypes.coa_types.coaAR: {
                descSuffix = "Payment";
                break;
              }
              case IceTypes.coa_types.coaCoPayAR: {
                descSuffix = "Co-Payment";
                break;
              }
              case IceTypes.coa_types.coaCoInsuranceAR: {
                descSuffix = "Co-Insurance Payment";
                break;
              }
              case IceTypes.coa_types.coaDeductibleAR: {
                descSuffix = "Deductible Payment";
                break;
              }
              case IceTypes.coa_types.coaDiscount:
              case IceTypes.coa_types.coaClaimAdjustment:
              case IceTypes.coa_types.coaDisallowedAdjustment:
              case IceTypes.coa_types.coaContractualObligationsAdjustment:
              case IceTypes.coa_types.coaCorrectionandReversalsAdjustment: {
                let foundAdj = this.payAdjTypes.filter(x => x.value == ctyp);
                if (foundAdj.length > 0) {
                  descSuffix = foundAdj[0].name;
                }
                else {
                  descSuffix = "Adjustment";
                }
                break;
              }
            }

            let credit = Iceutility.toDouble(rec.amount);
            balance -= credit;

            let entry = {
              journal_key: "",
              service_reference_key: rec.service_reference_key,
              medical_service_key: rec.medical_service_key,
              origical_date: thispost.pay_date,
              date: Iceutility.getDateTextEx(Iceutility.isTextDateTime(thispost.pay_date) ? thispost.pay_date : Iceutility.ConvertFromDotNetServerTime(thispost.pay_date)),
              trans_account: thispost.trans_account,
              account_type: Iceutility.toLong(thispost.account_type),
              coa_type: AccountingService.getCoaType(rec.coa_type),
              desc: rec.description + " - " + descSuffix + " - " + respName,
              note: "",
              code: "",
              otherifo: respName,
              charge: "",
              credit: -1.0 * credit,
              balance: balance
            };
            this.ledgerList.push(entry);
          }
        }

        //this.ledgerList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
      case this.acctHistoryPayments: {
        let postdata = this.history.getAllServicePostings(this.service.medical_service_key);
        for (const postkey in postdata) {
          let thispost: payment = postdata[postkey];
          for (let iref = 0; thispost != null && iref < thispost.SERVICES.length; iref++) {
            let rec: servicepaymentreference = thispost.SERVICES[iref];
            let respName = "", respKey = AccountingService.getPartyBucketKeyEx(rec.subscriber_key, rec.coverage_key, rec.payer_key);
            let foundResp = this.responsibleParties.filter(r => r.value == respKey);
            if (foundResp.length > 0)
              respName = foundResp[0].name;
            else
              respName = "Unknown";

            let payAdjTyp = "";
            let payAdjTypFound = this.payAdjTypes.filter(p => p.value == Iceutility.toLong(rec.coa_type));
            if (payAdjTypFound.length > 0)
              payAdjTyp = payAdjTypFound[0].name;
            else
              payAdjTyp = AccountingService.getCoaType(rec.coa_type);

            let payType = "N/A";
            if (thispost.payment_response === PaymentMethods.pmCash.toString()) {
              payType = "Cash";
            }
            let entry = {
              payment_key: thispost.payment_key,
              service_reference_key: rec.service_reference_key,
              medical_service_key: rec.medical_service_key,
              pay_date: Iceutility.getDateTextEx(Iceutility.isTextDateTime(thispost.pay_date) ? thispost.pay_date : Iceutility.ConvertFromDotNetServerTime(thispost.pay_date)),
              origical_date: thispost.pay_date,
              trans_account: thispost.trans_account,
              account_type: Iceutility.toLong(thispost.account_type),
              responsibleParty: respName,
              coa_type: payAdjTyp,
              description: rec.description,
              amount: Iceutility.toDouble(rec.amount),
              payref: thispost.reference_num,
              paytype: payType,
              cash_coa_type: Iceutility.toLong(thispost.cash_coa_type) == IceTypes.coa_types.coaNone ? "N/A" : AccountingService.getCoaType(thispost.cash_coa_type),
            };
            this.postingList.push(entry);
          }
        }

        this.postingList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });
        break;
      }
      case this.acctHistoryClaims: {
        let claimdata = this.history.getClaims(this.service.medical_service_key);
        for (let irec = 0; claimdata != null && irec < claimdata.length; irec++) {
          let rec: claimindex = <claimindex>claimdata[irec];
         
          let entry = {
            claim_key: rec.claim_key,
            claim_bucket_key: rec.claim_bucket_key.substr(0, 10) + "...",
            medical_service_key: rec.medical_service_key,
            date_required: rec.date_required,
            end_date_required: rec.end_date_required,
            code: rec.code,
            trans_account: rec.trans_account,
            account_type: Iceutility.toLong(rec.account_type),
            service_description: rec.service_description,
            status: MessageService.getStatus(Iceutility.toLong(rec.trans_status), IceTypes.SourceType.srcStatement),
            claim_date: rec.claim_date,
            total: rec.total_amount,
            last_message_text: ""
          };          
          this.medCodeSvc.dateConvert(entry, "date_required");
          this.medCodeSvc.dateConvert(entry, "end_date_required");
          this.medCodeSvc.dateConvert(entry, "claim_date");

          if (rec.last_message_key.length > 0) {
            this.medCodeSvc.getCodes("DATETIME_CODE", "", rec.last_message_date, "").subscribe(
              data => {
                if (data && data.length > 0) {
                  let bc: basecode = data[0];
                  let lastmsgdate = Iceutility.GetLocalDate(bc.title).toLocaleString();
                  let outboundmsg = MessageService.getStatus(Iceutility.toLong(rec.last_message_status), IceTypes.SourceType.srcStatement) + " on " + lastmsgdate;
                  if (rec.last_message_log.length > 0) outboundmsg += ", " + rec.last_message_log;
                  entry["last_message_text"] = outboundmsg;
                }
              },
              error => {
                console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
              });

          }

          this.claimList.push(entry);
        }

        break;
      }
    }
  }

  postChargeTypeChange(event) {
    if (event.value == IceTypes.coa_types.coaAR
      || event.value == IceTypes.coa_types.coaCoInsuranceAR
      || event.value == IceTypes.coa_types.coaCoPayAR
      || event.value == IceTypes.coa_types.coaDeductibleAR) {
      this.postPayType.setDisabled(false);
      this.postCashAccount.setDisabled(false);
    }
    else {
      this.postPayType.setDisabled(true);
      this.postCashAccount.setDisabled(true);
    }
  }

  postAmountKeyUp(event) {
    let postAmt = Iceutility.toDouble(this.postAmount.getFormControl().value);
    this.postAmount.getFormControl().setValue(postAmt);
  }

  postItemClick(event) {
    if (this.isReadyOnly() || this.history == null) return;

    // To do make date and amount required
    // don't allow editing if payments have been made
    // new post should be allowed to be edited
    let respKey = this.postResponsibleParty.getFormControl().value;
    let respName = "";
    let foundResp = this.responsibleParties.filter(r => r.value == respKey);
    if (foundResp.length > 0)
      respName = foundResp[0].name;
    else
      respName = "Unknown";

    let payAdjTypeName = "";
    let payAdjTyp = this.postChargeType.getFormControl().value;
    let payAdjTypFound = this.payAdjTypes.filter(p => p.value == Iceutility.toLong(payAdjTyp));
    if (payAdjTypFound.length > 0)
      payAdjTypeName = payAdjTypFound[0].name;
    else
      payAdjTypeName = AccountingService.getCoaType(payAdjTyp);

    let payDate = this.postDateCtrl.getFormControl().value;
    let postNote = this.postNotesCtrl.getFormControl().value;
    let refInfo = this.postRefCtrl.getFormControl().value;
    let amt = this.postAmount.getFormControl().value;
    let payType = this.postPayType.getFormControl().value;
    let cashCoa = this.postCashAccount.getFormControl().value;

    if (payAdjTyp != IceTypes.coa_types.coaAR
      && payAdjTyp != IceTypes.coa_types.coaCoInsuranceAR
      && payAdjTyp != IceTypes.coa_types.coaCoPayAR
      && payAdjTyp != IceTypes.coa_types.coaDeductibleAR) {
      payType = PaymentMethods.pmNone;
      cashCoa = IceTypes.coa_types.coaNone;
    }

    let post: payment = new payment();
    let allposting = this.history.getAllServicePostings(this.service.medical_service_key);
    if (allposting == null) {
      allposting = {};
      this.history.setAllServicePostings(this.service.medical_service_key, allposting);
    }

    post.payment_key = Iceutility.guid(true);
    post.pay_date = Iceutility.convertToUTCEx(payDate);
    post.account_type = Iceutility.toLong(this.service.account_type);
    post.trans_account = this.service.trans_account
    post.cash_coa_type = cashCoa;
    post.reference_num = refInfo;
    post.payment_response = payType == NaN ? "" : payType;
    post.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

    let svcpost: servicepaymentreference = new servicepaymentreference();
    svcpost.amount = amt;
    svcpost.coa_type = payAdjTyp;
    svcpost.description = postNote.length == 0 ? this.service.service_description : postNote;

    svcpost.service_reference_key = Iceutility.guid(false);
    svcpost.medical_service_key = this.service.medical_service_key;
    svcpost.other_items_key = this.service.other_items_key;
    svcpost.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    AccountingService.setPaymentSubscriberFromDDLKey(this.postResponsibleParty, svcpost);
    post.SERVICES.push(svcpost);

    allposting[post.payment_key] = post;

    let entry = {
      payment_key: post.payment_key,
      service_reference_key: Iceutility.guid(false),
      medical_service_key: this.service.medical_service_key,
      pay_date: Iceutility.getDateTextEx(payDate),
      origical_date: "",
      trans_account: this.service.trans_account,
      account_type: Iceutility.toLong(this.service.account_type),
      responsibleParty: respName,
      coa_type: payAdjTypeName,
      description: svcpost.description,
      amount: Iceutility.toDouble(amt),
      payref: refInfo,
      paytype: payType == PaymentMethods.pmNone ? "N/A" : "Cash",
      cash_coa_type: cashCoa == IceTypes.coa_types.coaNone ? "N/A" : AccountingService.getCoaType(cashCoa),
    };
    this.postingList.push(entry);
    this.postingList.sort(function (a, b) { return a.origical_date.localeCompare(b.origical_date) });

    this.resetPostingControls();

    // To track posting here, then if cancel is issued we can remove the new posting from allposting
    if (this.postPaymentClick.observers.length > 0) {
      event["payment"] = post;
      this.postPaymentClick.emit(event);
    }
  }

}
